import { TableProps } from 'antd';
import ProtectedResource from 'components/RoleBasedAccessControl/ProtectedResource';
import { RizeUser } from 'types/common';
import { ROLE_GROUPS } from 'utils/constants';
import {
  isMobileScreenSize,
  matchTwoArrays,
  renderDate,
  renderInfoValue,
} from 'utils/helpers';

const tableDataStyle = {
  margin: 0,
  cursor: 'pointer',
};

const renderUsersTableHeader = (
  handleAction: (data: RizeUser, type: 'detail' | 'assign') => void,
): TableProps<RizeUser>['columns'] => [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    onCell: (data) => ({ onClick: () => handleAction(data, 'detail') }),
    render: (name) => (
      <p className="first-column-text" style={tableDataStyle}>
        {renderInfoValue(name, 'N/A')}
      </p>
    ),
    sorter: true,
    fixed: 'left',
    width: isMobileScreenSize ? '12%' : undefined,
  },
  {
    title: 'Role',
    dataIndex: 'roles',
    key: 'roles',
    render: (roles) => (
      <p style={tableDataStyle}>{renderInfoValue(roles?.join(', '), 'N/A')}</p>
    ),
    sorter: true,
  },
  {
    title: 'Reporting to',
    dataIndex: 'reportingToUserEmailList',
    key: 'reportingToUserEmailList',
    render: (reportingToUserEmailList, data) => (
      <>
        {reportingToUserEmailList.length > 0 ? (
          <p style={tableDataStyle}>{reportingToUserEmailList.join(', ')}</p>
        ) : matchTwoArrays(ROLE_GROUPS.JR_AGS, data?.roles ?? []) ? (
          <ProtectedResource permission="user:assign" fallback="N/A">
            <span
              className="add-report-btn"
              onClick={() => handleAction(data, 'assign')}
            >
              Add Reporting to
            </span>
          </ProtectedResource>
        ) : (
          'N/A'
        )}
      </>
    ),
    sorter: true,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: (email) => (
      <p style={tableDataStyle}>{renderInfoValue(email, 'N/A')}</p>
    ),
    sorter: true,
  },
  {
    title: 'Phone Number',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    render: (phoneNumber) => (
      <p style={tableDataStyle}>{renderInfoValue(phoneNumber, 'N/A')}</p>
    ),
  },
  {
    title: 'Country',
    dataIndex: 'country',
    key: 'country',
    render: (country) => (
      <p style={tableDataStyle}>{renderInfoValue(country, 'N/A')}</p>
    ),
    sorter: true,
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt) => (
      <p style={tableDataStyle}>{renderDate(createdAt, 'N/A')}</p>
    ),
    sorter: true,
  },
];

export default renderUsersTableHeader;
